<template>
    <div style="background-color: #eeeeee;padding-bottom: 60px;">
        <img style="display: block;margin: 0 auto;" src="../../assets/banner12.png" alt="">
        <div class="main">
            <ul class="Breadcrumb">
                <li @click="backPage('/home')">首页</li>
                <li>></li>
                <li @click="backPage('-1')">加入士模</li>
                <li>></li>
                <li>{{ type }}</li>
            </ul>
            <h3 class="tab_title">{{ type }}</h3>
            <div v-show="!isDetail">
                <div style="overflow: hidden;">
                <div class="fleft left">
                    <p><span>{{ total }}</span>个在招职位</p>
                </div>
                <div class="fleft center">
                    <div>
                        <ul class="condition">
                            <li>工作地点:</li>
                            <li @click="condition('area', '')" :class="area == '' ? 'active' : ''">全部</li>
                            <li :class="area == item.dictValue ? 'active' : ''" @click="condition('area', item.dictValue)"
                                v-for="(item, index) in areaList">{{ item.dictLabel }}</li>
                        </ul>
                        <ul class="condition">
                            <li>岗位类别:</li>
                            <li @click="condition('category', '')" :class="category == '' ? 'active' : ''">全部</li>
                            <li :class="category == item.dictValue ? 'active' : ''" @click="condition('category', item.dictValue)"
                                v-for="(item, index) in categoryList">{{ item.dictLabel }}</li>
                        </ul>
                    </div>
                </div>
                <div class="fright right">
                    <div class="search">
                        <input placeholder="搜索职位名称" type="text" v-model="name">
                        <img @click="getList" src="../../assets/icon21.png" alt="">
                    </div>
                </div>
            </div>
            <table border="1">
                <tr>
                    <th>岗位名称</th>
                    <th>岗位类别</th>
                    <th>工作地点</th>
                    <!-- <th>发布时间</th> -->
                </tr>
                <tr  @click="check(item)" :class="index%2?'active':''" v-for="(item,index) in list">
                    <td>{{item.name}}</td>
                    <td>{{ getDictLabel(categoryList,item.category) }}</td>
                    <td>{{ getDictLabel(areaList,item.area) }}</td>
                    <!-- <td>{{ item.createTime.split(' ')[0] }}</td> -->
                </tr>
            </table>
            <p class="email">简历投递邮箱：HR@cimomicro.com</p>

            </div>
            
            <div class="detail" v-if="isDetail">
                <span class="close" @click="isDetail = false"><img src="./../../assets/icon22.png" alt=""></span>
                <h3 class="name">{{ detail.name }}</h3>
                <p>{{ getDictLabel(areaList,detail.area) }}
                {{ getDictLabel(categoryList,detail.category) }}</p>
                
                <div style="background-color:#c7c7c7;margin:20px 0;height: 1px;"></div>
                <p class="dept">岗位职责</p>
                <div class="editer" style="padding:0 20px;" v-html="detail.responsibility"></div>
                <p class="dept">岗位要求</p>
                <div class="editer" style="padding:0 20px;" v-html="detail.requirements"></div>
                <p class="email">简历投递邮箱：{{ detail.email }}</p>
            </div>

        </div>
    </div>
</template>
<script>
import { getDictList, getRecruitmentList,getRecruitmentDetail } from '../../api/index'
import {getDictLabel} from '../../utils/common'
import {backPage} from '@/utils/common'
export default {
    data() {
        return {
            type: "",
            total: 0,
            list: [],
            category: "",
            area: "",
            name: '',
            areaList: [],
            isDetail:false,
            detail:{},
            categoryList: [],
        }
    },
    methods: {
        getList() {
            let params = {
                category: this.category,
                area: this.area,
                name: this.name,
                pageSize:100
            }
            getRecruitmentList(params).then(res => {
                this.list = res.rows
                this.total = res.total
            })
        },
        condition(key, value) {
            this[key] = value
            this.getList()
        },
        check(item){
            console.log(item);
            getRecruitmentDetail(item.id).then(res =>{
                this.detail = res.data
                this.isDetail = true
            })
        },
        getDictLabel,
        backPage,
    },
    mounted() {
        this.type = this.$route.query.type
        this.category = this.$route.query.id
        getDictList('cms_recruitment_category').then(res => {
            this.categoryList = res.data
        })
        getDictList('cms_recruitment_area').then(res => {
            this.areaList = res.data
        })

        this.getList()
    }
}
</script>
<style lang="scss" scoped>
.title {
    border-left: 10px solid #d60e4c;
    line-height: 36px;
    text-indent: 30px;
    font-weight: bold;
    font-size: 36px;
    margin-bottom: 40px;
    color: #2e2e2e;
}

.left {
    width: 25%;

    p {
        font-size: 18px;

        span {
            font-size: 30px;
            display: inline-block;
            margin-right: 4px;
        }
    }
}

.condition {
    margin-bottom: 10px;
    overflow: hidden;
    li {
        float: left;
        margin-right: 10px;
        cursor: pointer;
        font-weight: normal;
    }

    li.active {
        font-weight: bolder;
    }
}
.search{
    width: 300px;
    height: 40px;
    background-color: #fff;
    border: 1px solid #c7c7c7;
    box-sizing: border-box;
    input{
        border: none;
        width: 240px;
        height: 38px;
        float: left;
        font-size: 16px;
        text-indent: 10px;
    }
    img{
        width: 26px;
        float: right;
        margin-top: 7px;
        margin-right: 10px;
        cursor: pointer;
    }
}
table,
td,
th {
    text-align: center;
    border: 1px solid #cbcbcb;
    border-collapse: collapse;
    p{
        line-height: 30px;
        margin-bottom: 10px;
    }
}
table {
    width: 100%;
    margin-top: 30px;
}

table td {
    line-height: 40px;
}

th {
    line-height: 50px;
    background-color: #d60e4c;
    color: #fff;
}

td {
    background-color: #fff;
    cursor: pointer;
    color: #2d2d2d;
}

tr.active{
    td{
        background-color: #eeeeee;
    }
}
tr:hover{
    td{
        color: #d60e4c;
    }
}
.detail{
    margin-top: 30px;
    background-color: #fff;
    box-shadow: 0 0 5px 1px #bbb8b8;
    padding: 50px 40px;
    position: relative;
    .close{
        position: absolute;
        display: block;
        font-weight: bolder;
        cursor: pointer;
        right: 14px;
        top: 14px;
        width: 20px;
    }
    .name{
        font-size: 24px;
        font-weight: bold;
        line-height: 44px;
    }
    p{
        font-size: 16px;
    }
    .dept{
        margin: 40px 0 10px 0;
        font-weight: bold;
        font-size: 18px;
    }
    
}
.email{
        background-color: #d60e4c;
        color: #fff;
        display: table;
        margin: 60px auto 0;
        padding: 8px 30px;
        font-size: 16px;
    }
</style>


// WEBPACK FOOTER //
// src/views/recruit/index.vue